/// <reference  types="@types/googlemaps"  />

import { Component, ViewChild, EventEmitter, Output, OnInit, AfterViewInit, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-app-auto',
  templateUrl: './app-auto.component.html',
  styleUrls: ['./app-auto.component.css']
})
export class AppAutoComponent implements OnInit {
 
  @Input() adressType: string;
  @Input() LatLng = {}
  @Input() strictBounds: boolean
  @Input() title: boolean

  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  @ViewChild('addresstext') addresstext: any;

  autocompleteInput: string;
  queryWait: boolean;
  defaultBounds
  constructor() {
  }

  ngOnInit() {

    setTimeout(()=>{
      console.log(this.LatLng,'datajjk')
    })
  }

  // ngAfterViewInit() {
  //   this.getPlaceAutocomplete();
  // }


  ngOnChanges(changes: SimpleChanges) {


    if (changes['strictBounds']['previousValue'] != undefined) {
      console.log(changes, 'changes')
      this.getPlaceAutocomplete();
    }
  }



  private getPlaceAutocomplete() {

    let center: any = { lat: this.LatLng['lat'], lng: this.LatLng['lng'] };

    const defaultBounds = {
      north: center.lat + 0.1,
      south: center.lat - 0.1,
      east: center.lng + 0.1,
      west: center.lng - 0.1,
    };
    
    const options = {
      bounds: defaultBounds,
      radius: '10000000',
      strictBounds: this.strictBounds,
    }
    const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement)
    // {
    //     componentRestrictions: { country: 'US' },
    //     types: [this.adressType]  // 'establishment' / 'address' / 'geocode'
    // });
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();
      this.invokeEvent(place);
    });
  }

  invokeEvent(place: Object) {
    this.setAddress.emit(place);
  }

}
